<template>
  <div class="datav-map-main">
    <div class="filter">
      <SearchInput v-model="activeLocal" :arr="equips" @select="searchEquip"></SearchInput>
    </div>
    <div id="datav-map-main" style="height:100%; width:100%;"></div>
  </div>
</template>
<script>
// import "echarts/map/js/china.js";
// import 'echarts/extension/bmap/bmap';
import { debounce } from "@/utils/common";
import { equipMapApi } from "@/api/rms/rmsEquipApi";

// STATUS_CONFIG
const STATUS_CONFIG = {
  equipsOffline: { type: 'scatter', color: '#ddb926' },
  equipsOnline: { type: 'scatter', color: '#007aff' },
  equipsRunning: { type: 'effectScatter', color: '#07c160' },
  equipsAlarming: { type: 'effectScatter', color: '#f43530' }
};
// 生成系列配置
const generateSeries = (name, type, color) => ({
  name,
  type,
  coordinateSystem: 'geo',
  symbolSize: type === 'effectScatter' ? 10 : 8,
  ...(type === 'scatter' && {
    large: true,
    largeThreshold: 200,
  }),
  progressive: 100,    // 分批渲染
  itemStyle: { color, opacity: 0.8 },
  data: [],
  label: {
    show: false,
    position: 'right',
    formatter: ({ name }) => name
  },
  ...(type === 'effectScatter' && {
    showEffectOn: 'emphasis',
    rippleEffect: { brushType: 'stroke' },
    hoverAnimation: true
  })
});
export default {
  components: {
    SearchInput: ()=> import("./SearchInput.vue")
  },
  data() {
    return {
      activeLocal: "",
      equips: [],
      mapChart: null,
      statusArr:[ 
        'equipsOffline',
        'equipsOnline',
        'equipsRunning',
        'equipsAlarming',
      ],
      query: {
        pindex: 1,
        psize: 500,
      },
      total: 0,
      mapChartOption: {
        zoom: 1.2, //当前视角的缩放比例
        roam: true, //是否开启平游或缩放
        tooltip: {
          trigger: "item",
          backgroundColor: "rgba(100, 100, 100, .5)",
          enterable: true,
          padding: 15,
          extraCssText: "z-index: 2000;",
          position: function (point) {
            return point;
          },
          formatter: function (obj) {
            var data = obj.data;
            return `
              <a href="javascript:;" onclick="onDatavMapTooltipClick(${data.equipid})">
                <div>
                  <span>${data.name}</span>
                  <span class="ml-xs">${data.status}</span>
                </div>
              </a>
            `;
          },
        },
        legend: {
          orient: "horizontal",
          left: 20,
          top: 30,
          data: ["所有", "在线", "运行", "告警"],
          textStyle: {
            color: "#f3f3f3",
          },
        },
        geo: {
          map: "china",
          roam: true,
          top: 0,
          bottom: 0,
          itemStyle: {
            normal: {
              areaColor: "#323c48",
              borderColor: "#111",
            },
            emphasis: {
              areaColor: "transparent",
            },
          },
          label: {
            emphasis: {
              show: true,
              textStyle: {
                color: "#dddddd",
              },
            },
          },
        },
        series: Object.entries(STATUS_CONFIG).map(([key, cfg]) => 
          generateSeries(key, cfg.type, cfg.color)
        ),
      },

      timerId: null,
      timerId1: null,

      list1: [],
      list2: [],
      list3: [],
      list4: [],

      currentMapZoom: 1.2,
    };
  },

  computed: {
    equipsOffline() {
      return this.equips.filter((equip) => equip.status_num == 1);
    },
    equipsOnline() {
      return this.equips.filter((equip) => equip.status_num == 2);
    },
    equipsRunning() {
      return this.equips.filter((equip) => equip.status_num == 3);
    },
    equipsAlarming() {
      return this.equips.filter((equip) => equip.status_num == 4);
    },
    equipids() {
      return this.equips.map((v) => v.equipid);
    }
  },

  watch: {
  },

  created() {
    this.fetchData(true);
  },

  mounted() {
    const _this = this;
    window.onDatavMapTooltipClick = function (equipid) {
      _this.emit(equipid);
    };

    this.initMapChart();
    this.__resizeHandler = debounce(() => {
      if (this.mapChart) {
        this.mapChart.resize();
      }
    }, 100);
    window.addEventListener("resize", this.__resizeHandler);
  },

  beforeDestroy() {
    if (this.mapChart) {
      this.mapChart.dispose();
      this.mapChart = null;
    }
    window.removeEventListener("resize", this.__resizeHandler);
    this.stopInterval()
  },

  beforeRouteLeave(to, from, next) {
    this.stopInterval()
    next();
  },

  methods: {
    stopInterval() {
      if (this.timerId) {
        clearTimeout(this.timerId)
        this.timerId = null
      }
      if (this.timerId1) {
        clearTimeout(this.timerId1)
        this.timerId1 = null
      }
    },

    checkStatus(equip) {
      let status_num = 1;
      if (equip.is_online) status_num = 2;
      if (equip.is_online && equip.is_running) status_num = 3;
      if (equip.is_online && equip.is_alarm) status_num = 4;
      return status_num;
    },

    fetchData(update,poll) {
      if (update) {
        this.query.pindex = 1;
      }
      equipMapApi(this.query).then((res) => {
        if (!res.errno) {
          let list1 = [],
            list2 = [],
            list3 = [],
            list4 = [];
          let reslist = res.data.list.map((v) => {
            let item = {
              value: [v.location.lng, v.location.lat],
              status_num: this.checkStatus(v),
              equipid: v.equipid,
              status: v.status,
              name: v.name,
              go: v.go,
            };

            if (v.is_online && v.is_alarm && v.is_running) item.status = '告警运行'
            if (v.is_online && v.is_alarm && !v.is_running) item.status = '告警'
            if (v.is_online && !v.is_alarm && v.is_running) item.status = '正常运行'
            if (v.is_online && !v.is_alarm && !v.is_running) item.status = '在线'

            if (item.status_num == 1) {
              list1.push(item);
            } else if (item.status_num == 2) {
              list2.push(item);
            } else if (item.status_num == 3) {
              list3.push(item);
            } else if (item.status_num == 4) {
              list4.push(item);
            }
            return item;
          });
          
          this.addData(list1, list2, list3, list4, poll)
          if(!poll) {
            if (this.query.pindex == 1) {
              this.equips = reslist;
            } else {
              this.equips = this.equips.concat(reslist);
            }
          } else {
            reslist.map(item => {
              let index = this.equips.findIndex(v => v.equipid == item.equipid);
              if(index >= 0) {
                this.equips.splice(index,1,item)
              } else {
                this.equips.push(item)
              }
            })
          }
          
          if (this.query.pindex < Math.ceil(res.data.total / this.query.psize)) {
            this.query.pindex++;
            let _this = this;
            if (_this.timerId) {
              clearTimeout(_this.timerId)
              _this.timerId = null
            }
            _this.timerId1 = setTimeout(() => {
              _this.fetchData(false, poll);
            }, 300);
          } else {
            let _this = this;
            if (_this.timerId1) {
              clearTimeout(_this.timerId1)
              _this.timerId1 = null
            }
            _this.timerId = setTimeout(() => {
              _this.fetchData(true,true);
            }, 5000);
          }
        }
      });
    },

    async initMapChart() {
      // 🔥 关键：页面不卡后，再异步加载中国地图
      if (!window.chinaJson) {
        await import("echarts/map/js/china.js");
      }
      this.mapChart = this.$echarts.init(
        document.getElementById("datav-map-main"),
        "teenager"
      );
      this.refreshMapChart();

      const _this = this;
      // 点单击事件
      this.mapChart.on("click", "series", function (e) {
        _this.emit(e.data.equipid);
      });

      this.mapChart.on('georoam', () => {
        // 正确获取缩放等级：必须取 geo[0].zoom
        const currentOption = this.mapChart.getOption();
        const currentZoom = currentOption.geo[0].zoom;
        
        // console.log('✅ 地图缩放等级：', currentZoom);
        this.currentMapZoom = currentZoom;
      })
    },

    addData(list1, list2, list3, list4, poll) {
      if(poll) {
        list1.map(item => {
          let index1 = this.list1.findIndex(v => v.equipid == item.equipid);
          let index2 = this.list2.findIndex(v => v.equipid == item.equipid);
          let index3 = this.list3.findIndex(v => v.equipid == item.equipid);
          let index4 = this.list4.findIndex(v => v.equipid == item.equipid);
          if(index1 > -1) {
            this.list1.splice(index1, 1, item);
          } else {
            this.list1.push(item);
          }
          if(index2 > -1) {
            this.list2.splice(index2, 1);
          }
          if(index3 > -1) {
            this.list3.splice(index3, 1);
          }
          if(index4 > -1) {
            this.list4.splice(index4, 1);
          }
        })
        list2.map(item => {
          let index1 = this.list1.findIndex(v => v.equipid == item.equipid);
          let index2 = this.list2.findIndex(v => v.equipid == item.equipid);
          let index3 = this.list3.findIndex(v => v.equipid == item.equipid);
          let index4 = this.list4.findIndex(v => v.equipid == item.equipid);
         
          if(index1 > -1) {
            this.list1.splice(index1, 1);
          }
          if(index2 > -1) {
            this.list2.splice(index2, 1, item);
          } else {
            this.list2.push(item);
          }
          if(index3 > -1) {
            this.list3.splice(index3, 1);
          }
          if(index4 > -1) {
            this.list4.splice(index4, 1);
          }
        })
        list3.map(item => {
          let index1 = this.list1.findIndex(v => v.equipid == item.equipid);
          let index2 = this.list2.findIndex(v => v.equipid == item.equipid);
          let index3 = this.list3.findIndex(v => v.equipid == item.equipid);
          let index4 = this.list4.findIndex(v => v.equipid == item.equipid);
          if(index1 > -1) {
            this.list1.splice(index1, 1);
          }
          if(index2 > -1) {
            this.list2.splice(index2, 1);
          }
          if(index3 > -1) {
            this.list3.splice(index3, 1, item);
          } else {
            this.list3.push(item);
          }
          if(index4 > -1) {
            this.list4.splice(index4, 1);
          }
        })
        list4.map(item => {
          let index1 = this.list1.findIndex(v => v.equipid == item.equipid);
          let index2 = this.list2.findIndex(v => v.equipid == item.equipid);
          let index3 = this.list3.findIndex(v => v.equipid == item.equipid);
          let index4 = this.list4.findIndex(v => v.equipid == item.equipid);
          if(index1 > -1) {
            this.list1.splice(index1, 1);
          }
          if(index2 > -1) {
            this.list2.splice(index2, 1);
          }
          if(index3 > -1) {
            this.list3.splice(index3, 1);
          }
          if(index4 > -1) {
            this.list4.splice(index4, 1, item);
          } else {
            this.list4.push(item);
          }
        })
      } else {
        this.list1 = this.list1.concat(list1);
        this.list2 = this.list2.concat(list2);
        this.list3 = this.list3.concat(list3);
        this.list4 = this.list4.concat(list4); 
      }
      this.mapChartOption.series[0].data = this.list1;
      this.mapChartOption.series[1].data = this.list2;
      this.mapChartOption.series[2].data = this.list3;
      this.mapChartOption.series[3].data = this.list4;
      
      if (this.mapChart) {
        this.mapChart.setOption(this.mapChartOption);
      }
    },

    refreshMapChart() {
      this.mapChartOption.series[0].data = this.equipsOffline;
      this.mapChartOption.series[1].data = this.equipsOnline;
      this.mapChartOption.series[2].data = this.equipsRunning;
      this.mapChartOption.series[3].data = this.equipsAlarming;
      if (this.mapChart) {
        this.mapChart.setOption(this.mapChartOption);
      }
    },

    searchEquip(val){
      if(!val) return;
      let centerObj = {
        center: val.value,
        layoutCenter: ['50%','50%'],
        layoutSize: '400%'
      }
      if(val.value[0] && val.value[1]){  
        this.mapChart.clear();//二级地图无法居中解决方法
        this.mapChartOption = {...this.mapChartOption, ...centerObj}
        this.refreshMapChart();
      }

      this.highLightEquip(val.equipid);
      var _this = this;
      setTimeout(() => {
        _this.emit(val.equipid)
      }, 1000)
    },

    highLightEquip(equipid) {
      if (!this.mapChart) return;
      
      const dataIndex = this.equipids.indexOf(equipid);
      if (dataIndex < 0) return;
      const seriesIndex = this.equips[dataIndex].status_num - 1;
      const dIndex = this[this.statusArr[seriesIndex]].findIndex( (item) => item.equipid == equipid);
      this.mapChart.dispatchAction({
        type: "showTip",
        seriesIndex,
        dataIndex: dIndex,
      });
    },

    emit(equipid) {
      this.$emit("equip-click", equipid);
    },
  },
};
</script>
<style lang="scss" scoped>
.datav-map-main {
  position: relative;
  .filter{
    position: absolute;
    width: 240px;
    left: 260px;
    top: 25px;
    z-index: 10;
  }
}
</style>
